/**
 * What Evidence chat can do in this deployment (MOD-1726, guardrail F9).
 *
 * One app-wide value, published by `EvidenceCapabilitiesSync` from
 * `@heidi/evidence/data`'s `useQueryEvidenceCapabilities`, so the composer UI
 * and the request builders (`includeWebSearchAtom`, the fail-open send in
 * `useChatStream`) read the same answer — the request builders from the jotai
 * store at send time.
 */
import { isOnPrem } from '@/utils/buildProfile';
import {
  resolveEvidenceCapabilities,
  type EvidenceCapabilities,
} from '@heidi/evidence/contracts';
import { atom, useAtomValue } from 'jotai';

/**
 * ON-PREM-GATE: whether this build asks the backend at all. A cloud build's
 * answer is fixed, so it makes no request; one on-prem image serves every
 * egress posture, so an appliance asks at runtime. The build decides whether
 * to ask (F8); the backend decides the answer (F9).
 */
export const areEvidenceCapabilitiesReportedByBackend: boolean = isOnPrem;

/**
 * Starts at the answer before anything has loaded: unrestricted on cloud, the
 * most restrictive value on an appliance until the backend says otherwise.
 */
export const evidenceCapabilitiesAtom = atom<EvidenceCapabilities>(
  resolveEvidenceCapabilities({
    reportedByBackend: areEvidenceCapabilitiesReportedByBackend,
    response: undefined,
  })
);

export const useEvidenceCapabilities = (): EvidenceCapabilities =>
  useAtomValue(evidenceCapabilitiesAtom);
